function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class ParserError extends Error {
    constructor(message, hostname){
        super(message);
        _define_property(this, "hostname", void 0);
        this.name = 'StripeLink ParserError';
        this.hostname = hostname;
    }
}
const qualifiedMydevFormat = /^([\w\d_]+)-([\w-_]+)--([\w_-]+)-mydev\.dev\.stripe\.me$/;
export const parseMydevHost = (hostname)=>{
    const qualifiedMydevMatch = hostname.match(qualifiedMydevFormat);
    if (qualifiedMydevMatch) {
        return {
            user: qualifiedMydevMatch[1],
            qualifier: qualifiedMydevMatch[2],
            serviceName: qualifiedMydevMatch[3]
        };
    } else {
        throw new ParserError('could not parse mydev hostname', hostname);
    }
};
const fullstackPRRFormat = /^([\w\d_]+)-([\w-_]+)--([\w_-]+)-(iso|dev|corpiso)\.dev\.stripe\.me$/;
export const parseFullstackPRRHost = (hostname)=>{
    const fullstackPRRMatch = hostname.match(fullstackPRRFormat);
    if (fullstackPRRMatch) {
        return {
            user: fullstackPRRMatch[1],
            qualifier: fullstackPRRMatch[2],
            serviceName: fullstackPRRMatch[3],
            type: fullstackPRRMatch[4]
        };
    } else {
        throw new ParserError('could not parse fullstack PRR hostname', hostname);
    }
};
const internalHostnameFormat = /^([\w_-]+)(?:\.(qa|preprod))?\.corp\.(?:stripe\.com|link\.com)$/;
const externalHostnameFormat = /^(?:(qa-edge|edge|qa|preprod)-)?([\w_-]+)\.(?:stripe\.com|link\.com)$/;
const rootHostnameFormat = /^(?:(qa-edge|edge|qa|preprod)\.)?(stripe\.com|link\.com)$/;
// Root hostnames required fixed configuration
// as their information cannot be automatically
// extracted from the URL.
export const ROOT_HOSTNAME_SERVICE_DATA = {
    'stripe.com': {
        serviceName: 'site',
        domain: 'stripe.com'
    },
    'link.com': {
        serviceName: 'mkt',
        domain: 'link.com'
    }
};
export const parseDeployedHost = (hostname)=>{
    const internalHostnameMatch = hostname.match(internalHostnameFormat);
    const externalHostnameMatch = hostname.match(externalHostnameFormat);
    const rootHostnameMatch = hostname.match(rootHostnameFormat);
    if (internalHostnameMatch) {
        const serviceName = internalHostnameMatch[1];
        const envMatch = internalHostnameMatch[2];
        const env = envMatch !== null && envMatch !== void 0 ? envMatch : 'production';
        return {
            type: 'internal',
            env,
            serviceName
        };
    // NB: It is important for this condition to come before
    // the externalHostnameMatch branch because that pattern will
    // always match hosts which also match this pattern,
    // but we want to be more explicit about this case
    } else if (rootHostnameMatch) {
        var _ROOT_HOSTNAME_SERVICE_DATA_hostMatch;
        const envMatch = rootHostnameMatch[1];
        const hostMatch = rootHostnameMatch[2];
        const serviceName = ((_ROOT_HOSTNAME_SERVICE_DATA_hostMatch = ROOT_HOSTNAME_SERVICE_DATA[hostMatch]) === null || _ROOT_HOSTNAME_SERVICE_DATA_hostMatch === void 0 ? void 0 : _ROOT_HOSTNAME_SERVICE_DATA_hostMatch.serviceName) || 'site';
        const env = envMatch !== null && envMatch !== void 0 ? envMatch : 'production';
        return {
            type: 'external',
            env,
            serviceName
        };
    } else if (externalHostnameMatch) {
        const envMatch = externalHostnameMatch[1];
        const serviceName = externalHostnameMatch[2];
        const env = envMatch !== null && envMatch !== void 0 ? envMatch : 'production';
        return {
            type: 'external',
            env,
            serviceName
        };
    } else {
        throw new ParserError('could not parse production hostname', hostname);
    }
};
const tunneledHostnameFormat = /^([\w\d_]+)-([\w-]+)\.tunnel\.stripe\.me$/;
export const parseTunneledHost = (hostname)=>{
    const tunneledHostMatch = hostname.match(tunneledHostnameFormat);
    if (tunneledHostMatch) {
        const user = tunneledHostMatch[1];
        const serviceName = tunneledHostMatch[2];
        return {
            user,
            serviceName
        };
    } else {
        throw new ParserError('could not parse tunneled hostname', hostname);
    }
};
const certhorseHostnameFormat = /^([\w\d_]+)-([\w_]+)-certhorse\.dev\.stripe\.me$/;
export const parseCerthorseHost = (hostname)=>{
    const certhorseHostMatch = hostname.match(certhorseHostnameFormat);
    if (certhorseHostMatch) {
        const certificationName = certhorseHostMatch[1];
        const serviceName = certhorseHostMatch[2];
        return {
            certificationName,
            serviceName
        };
    } else {
        throw new ParserError('could not parse certhorse hostname', hostname);
    }
};
export default {
    parseMydevHost,
    parseFullstackPRRHost,
    parseDeployedHost,
    parseTunneledHost,
    parseCerthorseHost
};

//# sourceMappingURL=parser.js.map